import isEmpty from "lodash/isEmpty"
import map from "lodash/map"
import each from "lodash/each"
export default {
  methods: {
    sort(by) {
      this.order = by
      this.orderName = this.orders[by].display
      this.showOrder = false;
    },
    buildSorting() {
      this.configuration.sortings = this.orders
    },
    buildDistance() {
      this.items = map(this.items, (item) => {
        each(this.visitorCenters, (loc, key) => {
          if (item.position) {
            item[key] = this.distance(loc.location.lat, loc.location.lng, item.position.lat, item.position.lng, "K")
          } else {
            item[key] = 999999
          }
        })

        return item
      })
    },
    distance(lat1, lon1, lat2, lon2, unit = "K") {
      if (lat1 == lat2 && lon1 == lon2) {
        return 999999
      } else {
        let radlat1 = (Math.PI * lat1) / 180
        let radlat2 = (Math.PI * lat2) / 180
        let theta = lon1 - lon2
        let radtheta = (Math.PI * theta) / 180
        let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
        if (dist > 1) {
          dist = 1
        }
        dist = Math.acos(dist)
        dist = (dist * 180) / Math.PI
        dist = dist * 60 * 1.1515

        if (unit === "K") {
          dist = dist * 1.609344
        }
        if (unit === "N") {
          dist = dist * 0.8684
        }

        return dist
      }
    },
    getLocation() {
      this.$getLocation({})
        .then((coordinates) => {
          //console.log(coordinates);
          this.coordinates = coordinates

          this.posts = map(this.posts, (item) => {
            item.distance = this.distance(coordinates.lat, coordinates.lng, item.position.lat, item.position.lng, "K").toFixed(2)
            return item
          })

          this.order = "distance"
        })
        .catch((msg) => {
          console.log(msg)
          alert("To sort by distance you allow access to your location")
          this.order = "relevance"
        })

      this.coordinatesTries++
    },
  },
  watch: {
    order(newValue) {
      if (newValue === "distance" && isEmpty(this.coordinates)) {
        this.getLocation()
      }
    },
  },
  data() {
    let orders = {
      recent: {
        text: "Most recent",
        display: "Most recent",
        order: 'desc',
        field: "timestamp",
      },
      oldest: {
        text: "Oldest first",
        display: "Oldest first",
        order: "asc",
        field: "timestamp",
      },
      name_asc: {
        text: "A to Z",
        display: "A to Z",
        order: "asc",
        field: "title",
      },
      name_desc: {
        text: "Z to A",
        display: "Z to A",
        order: "desc",
        field: "title",
      },
    }

    return {
      showOrder: false,
      orders: orders,
      order: "recent",
      orderName: "Most recent",
    }
  },
}
